<template>

  <form @submit.prevent="submit">
    <div class="row">
      <div class="input-field col s12 l6">
        <input v-model="domain" id="domain" placeholder="mastodon.domain" type="text" class="validate">
        <label class="active" for="domain">Mastodon domain</label>
      </div>
    </div>
    <button type="submit" class="waves-effect waves-light btn">Authenticate</button>
  </form>
</template>

<script>
import axios from 'axios'

import {createApp, getAxios, SCOPES} from '@/sources/mastodon'
import {getBaseUrl} from '@/utils'

export default {
  props: ["source"],
  data () {
    return {
      domain: '',
    }
  },
  mounted () {
    M.updateTextFields();
  },
  methods: {
    async submit () {
      let instanceUrl = `https://${this.domain}/`
      let baseUrl = getBaseUrl(window.location.toString(), this.$router.currentRoute.path)
      // create an application
      let ax = axios.create({
        baseURL: instanceUrl,
        timeout: 3000,
      })
      // we check wether the server is running pleroma or not, because
      // pleroma support lets scopes than Mastodon
      let scopes
      let instanceResponse = await ax.get('/api/v1/instance')
      let version = instanceResponse.data.version || ''
      if (version.toLowerCase().indexOf('(compatible; pleroma ')) {
        console.log('Pleroma detected, asking for "read" scope only!')
        scopes = 'read'
      } else {
        console.log('Mastodon detected, using standard scopes')
        scopes = SCOPES
      }
      let response = await createApp(ax, {baseUrl, scopes})
      const appData = response.data
      const redirectUri = encodeURIComponent(`${baseUrl}/connect/mastodon/callback`)
      this.$store.commit('setRecursiveState', {key: "sources.mastodon.appCredentials", suffix: this.domain, value: appData})
      let params = `response_type=code&scope=${encodeURIComponent(scopes)}&redirect_uri=${redirectUri}&state=${this.domain}&client_id=${appData.client_id}`
      const authorizeUrl = `${instanceUrl}oauth/authorize?${params}`
      console.log('Redirecting user...', authorizeUrl)
      window.location = authorizeUrl
    }
  }
}
</script>
